import cn from "classnames";
import { FontAwesomeIcon, type FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faUser,
  faChartPie,
  faShoppingCart,
  faFolderOpen,
  faShieldCheck,
} from "@fortawesome/pro-solid-svg-icons";
import AllArea from "../../images/check-square-solid.svg?react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";

import "./areaIcon.scss";

const withIcon = (icon: IconProp) => (props: FontAwesomeIconProps) => (
  <FontAwesomeIcon {...props} icon={icon} className={cn("fixedIconSize", "icon")} style={{ fontSize: 20 }} />
);

const iconsMap: Record<string, Function> = {
  All: (props: any) => <AllArea className="icon area-icon" {...props} />,
  Accounts: withIcon(faBuilding),
  People: withIcon(faUser),
  Reporting: withIcon(faChartPie),
  Marketplace: withIcon(faShoppingCart),
  Content: withIcon(faFolderOpen),
  "Threat Defense": withIcon(faShieldCheck),
};

export interface AreaIconProps {
  areaName: string;
}

const AreaIcon = ({ areaName, ...otherProps }: AreaIconProps) => {
  const component = iconsMap[areaName];
  return component(otherProps);
};

export default AreaIcon;
